const notification = {
  success: ({ message }) => {
    console.log(message);
  },
  error: ({ message }) => {
    console.error(message);
  }
};
export default notification
